import { UseQueryExecute } from 'urql';

import { createContext } from '@lyearn/core/utils/context';
import { ContentType } from '@/modules/corporate/modules/course/views/CourseBuilder/components/Sidebar/types';
import { CourseContentType } from '@/types/schema';

import useCourseActions from '../hooks/useCourseActions';

const COURSE_CONTEXT_NAME = 'Course';

export interface CourseContext extends ReturnType<typeof useCourseActions> {
  course: CourseContentType;
  lessonPageId: string | null;
  getSidebarIndex: (index: number, subIndex?: number | undefined) => string;
  courseContent?: ContentType[];
  refetchCourse?: UseQueryExecute;
}

export const [CourseContextProvider, useCourse] = createContext<CourseContext>(COURSE_CONTEXT_NAME);
